import React from 'react'
import { Text } from '@chakra-ui/react'
import { TTableCell } from '../types'

export const ellipsisCell: TTableCell<string> = (value) => (
  <Text
    fontSize="sm"
    overflow="hidden"
    textOverflow="ellipsis"
    whiteSpace="nowrap">
    {value}
  </Text>
)
